// DMFPlugin.js
const DMFPlugin = {
  install(Vue) {
    let dmfPromise = null;

    // Function to load DMF only once with error handling (timeout after 5 seconds)
    function loadDMF() {
      if (!dmfPromise) {
        dmfPromise = new Promise((resolve, reject) => {
          // Dispatch the DMF load request asynchronously.
          setTimeout(() => {
            document.dispatchEvent(new Event('dmf-request-ready'));
          }, 0);

          // Set a timeout so we reject if DMF isn't loaded in time.
          const timeout = setTimeout(() => {
            reject(new Error("DMF did not load in time"));
          }, 5000);

          // Listen for the DMF ready event to resolve the promise.
          document.addEventListener('dmf-ready', (event) => {
            clearTimeout(timeout);
            resolve(event.detail.DMF);
          });
        });
      }
      return dmfPromise;
    }

    // Load DMF on app initialization and store the instance on Vue's prototype.
    loadDMF()
      .then((DMF) => {
        Vue.prototype.$dmf = DMF;
      })
      .catch((error) => {
        console.error("Failed to load DMF:", error);
        // Optionally, you could set Vue.prototype.$dmf to a fallback or leave it undefined.
      });

    // Attach a helper method for rescanning.
    // This method ensures DMF is loaded before calling rescan.
    Vue.prototype.$dmfRescan = function (el) {
      if (this.$dmf) {
        this.$dmf.rescan(el);
      } else {
        loadDMF()
          .then((DMF) => {
            DMF.rescan(el);
          })
          .catch((error) => {
            console.error("DMF could not be loaded, rescan skipped:", error);
            // Optionally, add fallback behavior here.
          });
      }
    };

    // Attach a helper method for getting the locale.
    // If DMF can't be loaded, return a default country code.
    Vue.prototype.$dmfGetCountryCode = function () {
      if (this.$dmf) {
        return Promise.resolve(
          `${this.$dmf.getCookie('selected_language')}_${this.$dmf.getCookie('selected_country')}`
        );
      } else {
        return loadDMF()
          .then((DMF) => {
            return `${DMF.getCookie('selected_language')}_${DMF.getCookie('selected_country')}`;
          })
          .catch((error) => {
            console.error("DMF could not be loaded, returning default country code:", error);
            // Return a default value if DMF can't be loaded.
            return "en_US";
          });
      }
    };
  },
};

export default DMFPlugin;
